import styled, { css } from 'styled-components';
import { SIDEBAR_MOBILE_BREAKPOINT } from '@constants/sidebar';
import {
  EDITOR_PANEL_HEADER_PAD,
  EDITOR_TOPBAR_HEIGHT,
} from '../editorLayout.constants';
import {
  DOCK_EXPAND_OVERHANG,
  DOCK_WIDTH_COLLAPSED,
  DOCK_WIDTH_OPEN,
} from '../dock/ProcessSidePanel.styled';
import {
  ASSISTANT_PANEL_WIDTH,
  ASSISTANT_RAIL_WIDTH,
} from './processAssistant.constants';

const TRANSITION = '280ms cubic-bezier(0.4, 0, 0.2, 1)';
const HEADER_PAD_X = 12;

const dockWidth = (collapsed: boolean): number =>
  collapsed ? DOCK_WIDTH_COLLAPSED : DOCK_WIDTH_OPEN;

export const AssistantRoot = styled.div<{
  $open: boolean;
  $dockCollapsed: boolean;
}>`
  position: fixed;
  top: ${EDITOR_TOPBAR_HEIGHT}px;
  right: ${({ $dockCollapsed }) => dockWidth($dockCollapsed)}px;
  bottom: 0;
  width: ${({ $open }) =>
    $open ? ASSISTANT_PANEL_WIDTH : ASSISTANT_RAIL_WIDTH}px;
  z-index: 12;
  display: flex;
  flex-direction: column;
  background: ${({ theme }) => theme.colors?.surface ?? '#0E0F18'};
  border-left: 1px solid
    ${({ theme }) => theme.colors?.outlineVariant ?? '#25263A'};
  transition: width ${TRANSITION}, right ${TRANSITION};

  @media (max-width: ${SIDEBAR_MOBILE_BREAKPOINT}px) {
    ${({ $open }) =>
      $open &&
      css`
        left: 0;
        right: 0;
        width: auto;
        z-index: 13;
      `}
  }
`;

export const AssistantHeader = styled.header<{ $dockCollapsed: boolean }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: ${EDITOR_PANEL_HEADER_PAD}px ${HEADER_PAD_X}px;
  flex-shrink: 0;
  border-bottom: 1px solid
    ${({ theme }) => theme.colors?.outlineVariant ?? '#25263A'};

  /* The dock's collapsed handle hangs over this panel's right edge — keep the
     close button clear of it so the two toggles don't read as one control. */
  ${({ $dockCollapsed }) =>
    $dockCollapsed &&
    css`
      padding-right: ${HEADER_PAD_X + DOCK_EXPAND_OVERHANG}px;
    `}
`;

export const AssistantTitleGroup = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const AssistantTitle = styled.h2`
  margin: 0;
  min-width: 0;
  ${({ theme: { font } }) => css`
    ${font?.titleSmall}
  `}
  color: ${({ theme }) => theme.colors?.onSurface ?? '#E6E6F2'};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const AssistantStageSlot = styled.span`
  flex-shrink: 0;
  display: inline-flex;
`;

export const AssistantBody = styled.div<{ $hidden: boolean }>`
  flex: 1;
  min-height: 0;
  display: ${({ $hidden }) => ($hidden ? 'none' : 'flex')};
  flex-direction: column;
`;

export const AssistantRail = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: ${EDITOR_PANEL_HEADER_PAD}px 0;
`;

export const AssistantRailBusy = styled.span`
  display: inline-flex;
`;
